/**
 * /components/common/alert.jsにメッセージを表示するためのクラス
 */
class AlertContents {
  #type = "";
  #message = "";
  constructor(type, message) {
    this.#type = type;
    this.#message = message;
  }

  /**
   * アラートの種別
   */
  get type() {
    return this.#type;
  }

  /**
   * アラートに表示する本文
   */
  get message() {
    return this.#message;
  }

  /**
   * 無効であればtrueを返す
   */
  get isInvalid() {
    if (this.#type == null) {
      return true;
    }
    return false;
  }
}

/**
 * アラートのビルダークラス
 */
class AlertBuilder {
  /**
   * エラーアラートを作成する
   * @param {メッセージ} message
   */
  error(message) {
    return new AlertContents("error", message);
  }

  /**
   * 情報アラートを作成する
   * @param {メッセージ} message
   */
  info(message) {
    return new AlertContents("info", message);
  }

  /**
   * 成功アラートを作成する
   * @param {メッセージ} message
   */
  success(message) {
    return new AlertContents("success", message);
  }

  /**
   * 無効なアラートを作成する
   */
  invalid() {
    return new AlertContents(null, null);
  }
}

export default new AlertBuilder();
